/**
 * Cuts `value` down to `maxLength` characters, counting Unicode code points.
 * Whitespace left exposed by the cut is trimmed, so a name severed mid-word does
 * not reach the shipping label with a dangling space.
 *
 * Counting code points rather than `String.length` keeps the cut from severing a
 * surrogate pair and leaving a lone half in the value.
 */
export const truncateToMaxLength = (
  value: string,
  maxLength: number,
): string => {
  // eslint-disable-next-line @typescript-eslint/no-misused-spread -- deliberate: iterate code points, not UTF-16 units
  const characters = [...value]

  if (characters.length <= maxLength) {
    return value
  }

  return characters.slice(0, maxLength).join('').trimEnd()
}
